var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"counter":_vm.counter,"disabled":_vm.disabled,"rules":_vm.ruleList,"outlined":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }